<template>
  <div class="sy-multiple-choices">
    <component
      :is="newComponentName"
      v-on="$listeners"
      v-bind="{ ...$props, options: newOptions }"
    />
  </div>
</template>
<script>
  import selectMultipleChoices from './components/select-multiple-choices.vue'
  import rankRadioMultipleChoices from './components/rank-radio-multiple-choices.vue'
  import verticalRadioMultipleChoices from './components/vertical-radio-multiple-choices.vue'
  import readMultipleChoices from './components/read-multiple-choices.vue'
  import {multipleChoicesProps} from './index.js'

  export default {
    name: 'multiple-choices',
    props: multipleChoicesProps,
    data () {
      return {}
    },
    methods: {
      selectChange () {
        this.$emit('validateField')
      }
    },
    components: {
      selectMultipleChoices,
      rankRadioMultipleChoices,
      verticalRadioMultipleChoices,
      readMultipleChoices
    },
    computed: {
      newComponentName () {
        if (this.isPureText) {
          return 'readMultipleChoices'
        }
        if ((this.uiComponent && this.uiComponent === 1) || !this.uiComponent) {
          return 'selectMultipleChoices'
        } else if (
          this.uiComponent &&
          this.uiComponent === 2 &&
          this.selectedShowStyle === 1
        ) {
          return 'rankRadioMultipleChoices'
        } else if (
          this.uiComponent &&
          this.uiComponent === 2 &&
          this.selectedShowStyle === 2
        ) {
          return 'verticalRadioMultipleChoices'
        }
      },
      newOptions () {
        return this.options.filter(
          item => (item.state && this.value.includes(item.choiceKey)) || !item.state
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;

    .el-tag {
      height: auto;
      white-space: pre-wrap;
      word-break: break-word;
      -ms-word-break: break-all;
    }
  }

  .sy-multiple-choices {
    .multiple-box{
      line-height: 32px;
      ::v-deep .el-checkbox .el-checkbox__label{
        vertical-align: middle;
        max-width: 270px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
